<div class="modal__header">
  <h1 mat-dialog-title>
    {{data.header}}
  </h1>
  <span class="material-icons" (click)="exitDialog()">close</span>
</div>
<div class="modal__content" mat-dialog-content>
  <form [formGroup]="formOptions" (ngSubmit)="editAttr()" #formDirective="ngForm">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field>
          <input matInput type="text" formControlName="name_pl" placeholder="Nazwa atrybutu (PL)" />
          <mat-error *ngIf="formOptions.controls['name_pl'].errors?.required">
            Pole wymagane</mat-error>
        </mat-form-field>
        <mat-form-field>
          <textarea rows="3" matInput type="text" formControlName="description_pl" placeholder="Opis (PL)"></textarea>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-md-6">
        <mat-form-field>
          <input matInput type="text" formControlName="name_en" placeholder="Nazwa atrybutu (EN)" />
          <mat-error *ngIf="formOptions.controls['name_en'].errors?.required">
            Pole wymagane</mat-error>
        </mat-form-field>
        <mat-form-field>
          <textarea rows="3" matInput type="text" formControlName="description_en" placeholder="Opis (EN)"></textarea>
        </mat-form-field>
      </div>
    </div>
    <mat-form-field>
      <input matInput type="number" formControlName="orderBy" placeholder="Kolejność" />
      <mat-error *ngIf="formOptions.controls['orderBy'].errors?.required">
        Pole wymagane</mat-error>
    </mat-form-field>
    <mat-checkbox class="example-margin" formControlName="active">Atrybut aktywny</mat-checkbox>
  </form>
</div>
<div class="modal__footer mat_buttons" mat-dialog-actions>
  <button mat-raised-button color="default" (click)="exitDialog()">Zamknij</button>
  <button mat-raised-button type="submit" [disabled]="formOptions.invalid" (click)="formDirective.ngSubmit.emit()"
    color="primary">Zapisz</button>
</div>
